import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { EditMetadata } from '@caslink/common-client';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { CommandService } from '../../shared/services/command.service';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, debounceTime, skip } from 'rxjs/operators';
import {
    CommandOptimizationRenderingService
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

@Component({
    selector: 'dl-dynamic-element-list',
    templateUrl: './dynamic-element-list-input.component.html',
    styleUrls: ['../validation.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicElementListInputComponent extends DeviceInputBaseComponent implements OnDestroy {
    public static $name: string = 'dynamicElementList';

    public alertClass: string;
    public formControl: FormControl;

    public formMetadata: EditMetadata;

    private readonly debounceTime = 300;

    private valueChangesSubscription: Subscription;

    constructor(
        private commandService: CommandService,
        private themeService: ThemeService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }

    public ngOnInit() {
        this.alertClass = this.themeService.getTextAccentClass();

        super.ngOnInit();

        this.initFormMetadata();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.valueChangesSubscription?.unsubscribe();
    }

    public initFormMetadata() {
        this.formControl = this.deviceInputForm?.get(this.deviceInput.$fieldName) as FormControl || new FormControl(this.deviceInput.value, this.validators);
        this.deviceInputForm.addControl(this.deviceInput.$fieldName, this.formControl);

        this.formControl = new FormControl(this.deviceInput.value, this.validators);
        this.formControl.setValidators(this.validators);
        this.formControl.updateValueAndValidity();

        this.deviceInputForm.addControl(this.deviceInput.$fieldName, this.formControl);

        this.valueChangesSubscription = this.formControl.valueChanges.pipe(
            skip(1),
            debounceTime(this.debounceTime),
            distinctUntilChanged())
                .subscribe(() => {
                    this.invokeCommand();
                    this.cdr.detectChanges();
                });
    }

    public invokeCommand() {
        this.deviceInput.value = this.formControl.value;
        this.setSectionVisibility();
        this.invokeChangeCommand(this.deviceInput);
    }

    private get validators() {
        return [
            Validators.required,
            Validators.min(this.deviceInput.minValue),
            Validators.max(this.deviceInput.maxValue)
        ];
    }

    private setSectionVisibility() {
        if (this.formControl.valid) {
            this.deviceInput.$sections.forEach((val, ind) => {
                val.isVisible = ind < this.deviceInput.value;
            });
        }
    }
}
